var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 6,
    r: 5,
    stroke: "#092658",
    strokeWidth: 1.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.4322 20.5824C3.74125 17.9957 3.89577 16.7023 4.51204 15.7339C5.01698 14.9405 5.73384 14.3042 6.58156 13.8969C7.61619 13.3999 8.91877 13.3999 11.5239 13.3999H14.4761C17.0812 13.3999 18.3838 13.3999 19.4184 13.8969C20.2662 14.3042 20.983 14.9405 21.488 15.7339C22.1042 16.7023 22.2588 17.9957 22.5678 20.5824V20.5824C22.7199 21.8556 22.796 22.4922 22.5872 22.983C22.4167 23.3835 22.1202 23.7176 21.7427 23.9343C21.2802 24.1999 20.639 24.1999 19.3568 24.1999H6.6432C5.36096 24.1999 4.71984 24.1999 4.25732 23.9343C3.87979 23.7176 3.58329 23.3835 3.41284 22.983C3.20403 22.4922 3.28008 21.8556 3.4322 20.5824V20.5824Z",
    stroke: "#092658",
    strokeWidth: 1.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.2ce4807137ab2b9fd90d0239bad1b49f.svg";
export { ForwardRef as ReactComponent };